module.exports = __webpack_public_path__ + "r-v3/img/ml_01_00_over.7ec7927d.jpg";